<template>
  <span :class="{
    'counter': true,
    'counter-contrast': moreContrast
  }">
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'counter',
  props: {
    value: {
      type: Number,
      default: 0
    },
    moreContrast: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.counter {
  border: 1px solid $color-border;
  border-radius: 1.2rem;
  color: $color-text-light;
  font-size: 1.3rem;
  line-height: 2.4rem;
  margin-left: 1rem;
  padding: 0 .75rem;

  &.counter-contrast {
    background: #fff;
    border-color: $color-notice;
    color: $color-notice;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Counter.vue